import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialState, Others, Query } from "./initial";
import { RootState } from "../..";

export const getUsersUpdates = createAsyncThunk(
  "app/updates/updates",
  async (params, thunkAPI) => {
    try {
      const response = await `/updates/view`;
      return response;
    } catch (error: any) {
      const message = error.message.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateSlice = createSlice({
  name: "update",
  initialState,
  reducers: {
    setSearchParams: (state, { payload }: PayloadAction<Query>) => {
      state.query = payload;
    },
    setOtherParams: (state, { payload }: PayloadAction<Others>) => {
      state.others = payload;
    },
  },
  extraReducers: (builder) => {
    // builder;
  },
});

export default updateSlice.reducer;
export const SelectUpdate = (state: RootState) => state.update;
export const { setSearchParams, setOtherParams } = updateSlice.actions;
